(() => {
  const render = (root = document) => {
    root.querySelectorAll('[data-ww-delivery-min][data-ww-delivery-max]').forEach(element => {
      const min = Number(element.dataset.wwDeliveryMin);
      const max = Number(element.dataset.wwDeliveryMax);
      if (!Number.isFinite(min) || !Number.isFinite(max)) return;
      const label = `${min}–${max} business days, excluding weekends and public holidays`;
      if (element.textContent !== label) element.textContent = label;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(), { once: true });
  else render();
  document.addEventListener('shopify:section:load', event => render(event.target));
  document.addEventListener('variant:update', () => render());
})();
